import React, { useState, useEffect } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from 'reactstrap';
import { MyLocation } from '@mui/icons-material';
//constant
import { directUrl, homePageUrl } from '../../../helpers/Constants';
import { requestApi } from "../../../request-api";
// import { useLocation } from "react-router-dom";



//assets
// import logo from "../../../assets/image/logo-black.webp";
import logo from "../../../assets/image/Logo3.svg";
import { userStore } from '../../../stores';

function SuperAdminHeader(props) {

	let navigate = useNavigate()
	let { hideHeader } = props;
	const location = useLocation();
	let myLocation = location.pathname;
	//states
	let [isOpen, setIsOpen] = useState(false);
	const [user, setUser] = useState({});
	const isActive = myLocation.startsWith("/super-admin");




	//Mobile menu  
	const toggle = () => {
		setIsOpen(!isOpen)
	}
	const logout = () => {
		localStorage.clear();
		navigate(`${directUrl}sign-in`);
	}
	useEffect(() => {
		userData()

	}, []);
	const userData = () => {
		requestApi(`/superadmin/userData`, {
			method: "get",
		})
			.then((data) => {
				if (data.statusCode === 200) {
					setUser(data.data)
					// console.log("local storage::", user.name)
				} else {
				}
			})
			.catch((error) => {
				console.log("Error", error);
			});
	};
	const directToSetting = () => {
		navigate(`${directUrl}auditor/create-user-profile/settings`)
	}
	const { pathname } = useLocation();
	return (
		<>
			{!hideHeader && <header className='bs-header bs-head '>
				<Navbar expand="xl">
					<div className='navbar-outer'>
						<NavbarBrand >
							<NavLink exact to={'super-admin'}>
								{/* <img className='nav-logo' src={logo} alt='GLYPHER TECH LOGO' /> */}
								<img className='nav-logo' src={logo} alt='GLYPHER TECH LOGO' />
							</NavLink>
						</NavbarBrand>
						<NavbarToggler onClick={toggle} />
						<Collapse isOpen={isOpen} navbar>
							<Nav className="ml-auto" navbar>



								<NavItem>
									<NavLink
										className="nav-link"
										to="/super-admin"
										style={{
											textDecoration: "none",
											color: pathname === "/super-admin" ? "#000" : "#555",
											fontWeight: pathname === "/super-admin" ? "bold" : "normal",
										}}
									>
										<i
											className="icon-report"
											style={{
												color: pathname === "/super-admin" ? "#000" : "#555",
											}}
										/>
									Dashboard
									</NavLink>


								</NavItem>





								<NavItem>
									<NavLink
										className="nav-link"
										to="/super-admin/super-report"
										style={{
											textDecoration: "none",
											color: myLocation.includes("super-report") ? "#000" : "#555",
											fontWeight: myLocation.includes("super-report") ? "bold" : "normal",
										}}
									>
										<i
											className="icon-report"
											style={{
												color: myLocation.includes("super-report") ? "#000" : "#555",
											}}
										></i>
										Report
									</NavLink>
								</NavItem>



								<NavItem>
									<NavLink
										className="nav-link"
										to="/super-admin/super-user"
										style={{
											textDecoration: "none",
											color: myLocation.includes("super-user") ? "#000" : "#555",
											fontWeight: myLocation.includes("super-user") ? "bold" : "normal",
										}}
									>
										<i
											className="icon-report"
											style={{
												color: myLocation.includes("super-user") ? "#000" : "#555",
											}}
										></i>
										User
									</NavLink>
								</NavItem>

								<NavItem>
									<NavLink
										className="nav-link"
										to="/super-admin/super-company"
										style={{
											textDecoration: "none",
											color: myLocation.includes("super-company") ? "#000" : "#555",
											fontWeight: myLocation.includes("super-company") ? "bold" : "normal",
										}}
									>
										<i
											className="icon-report"
											style={{
												color: myLocation.includes("super-company") ? "#000" : "#555",
											}}
										></i>
										Company
									</NavLink>
								</NavItem>

								<NavItem>
									<NavLink
										className="nav-link"
										to="/super-admin/super-activelog"
										style={{
											textDecoration: "none",
											color: myLocation.includes("super-activelog") ? "#000" : "#555",
											fontWeight: myLocation.includes("super-activelog") ? "bold" : "normal",
										}}
									>
										<i
											className="icon-report"
											style={{
												color: myLocation.includes("super-activelog") ? "#000" : "#555",
											}}
										></i>
										Activity Log
									</NavLink>
								</NavItem>


								{/* <NavItem>
									<NavLink className='nav-link' to={`super-admin/client-table`}><i className='icon icon-client'></i>CLIENTS</NavLink>
								</NavItem> */}

							</Nav>
							<Nav className="ml-auto navbar-right" navbar>
								{/* <NavItem>
									<NavLink className='nav-link' to={`notifications`}><i className='icon icon-bell'></i></NavLink>
								</NavItem> */}
								{/* <UncontrolledDropdown className='user-drop' nav inNavbar>
									<DropdownToggle to={`notifications`} nav caret>
										<i className='icon icon-bell'></i>
									</DropdownToggle>
									<DropdownMenu right>
										<DropdownItem onClick={directToSetting}>Edit Profile</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
									</DropdownMenu>
								</UncontrolledDropdown> */}
								<UncontrolledDropdown className='user-drop' nav inNavbar>
									<DropdownToggle nav caret className="d-flex align-items-center">
										<img
											src="https://media.istockphoto.com/id/1223671392/vector/default-profile-picture-avatar-photo-placeholder-vector-illustration.jpg?s=612x612&w=0&k=20&c=s0aTdmT5aU6b8ot7VKm11DeID6NctRCpB755rA1BIP0="
											alt="User"
											style={{
												width: '32px',
												height: '32px',
												borderRadius: '50%',
												marginRight: '8px',
												objectFit: 'cover',
											}}
										/>
										<div className="d-none d-md-block text-start">
											<div style={{ fontWeight: 'bold', fontSize: '14px' }}>{user.name}</div>
											<div style={{ fontSize: '12px', color: '#777' }}>{user.email}</div>
										</div>
									</DropdownToggle>
									<DropdownMenu right>
										{/* <DropdownItem onClick={directToSetting}>Edit Profile</DropdownItem> */}
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
									</DropdownMenu>
								</UncontrolledDropdown>
							</Nav>
						</Collapse>
					</div>
				</Navbar>
			</header>}
		</>
	)
}

export default SuperAdminHeader
